import clsx from "clsx";
import { Link } from "react-router-dom";

import { date, text, rightColHeader } from "../styles";
import { routesFlat } from "@routes";
import { RocketIcon } from "@assets/icons";

export default function Featured() {
    return (
        <>
            <div className={rightColHeader}>featured product update</div>
            <Link to={"/jmrv"}>
                <div className={clsx(date + " mt-2 tracking-wider")}>
                    Nov 10, 2025
                </div>
                <div className={clsx(text + " line-clamp-3")}>
                    Carbon stock and emissions data for 2024 and Q1-Q3 2025 added to Jurisdictional MRV tool
                </div>
            </Link>

            <Link to="/jmrv" className="mt-1 flex text-sm font-bold">
                <RocketIcon />
                <div className="ml-2 border-b-[1px] border-b-red">
                    Learn More
                </div>
            </Link>
        </>
    );
}
